import React from 'react'

import {
  AlignItems,
  Body2,
  BorderStyle,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  FlexDirection,
  Heading2,
  Icon,
  JustifyContent,
} from '@gousto-internal/citrus-react'

export interface OrderOneOffBoxBannerProps {
  onOrderClick: () => void
}

export const OrderOneOffBoxBanner: React.FC<OrderOneOffBoxBannerProps> = ({ onOrderClick }) => (
  <Box
    display={Display.Flex}
    flexDirection={[FlexDirection.Column, FlexDirection.Row, FlexDirection.Row, FlexDirection.Row]}
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.SpaceBetween}
    bg={Color.White}
    gap={4}
    borderWidth={0.5}
    borderStyle={BorderStyle.Solid}
    borderRadius={1}
    paddingH={6}
    paddingV={6}
    data-testid="oneOffBoxBanner"
    style={{
      borderColor: '#EAEBEC',
    }}
  >
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Row}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.SpaceBetween}
      gap={4}
    >
      <Box
        bg={Color.Secondary_50}
        width={['40px', '64px', '64px', '64px']}
        height={['40px', '64px', '64px', '64px']}
        borderRadius="round"
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        style={{ flex: '0 0 auto', alignSelf: 'flex-start' }}
      >
        <Icon style={{ color: '#4538FA' }} name="meals_per_box" size={[5, 8, 8, 8]} />
      </Box>
      <Box
        style={{ flex: '1 1 auto' }}
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        gap={2}
      >
        <Heading2 size={[7, 9]} style={{ lineHeight: '32px' }}>
          Order a one-off box
        </Heading2>
        <Body2 size={4} style={{ lineHeight: '24px' }}>
          A single box when you need it. Ideal for special occasions, top-ups, or gifting.
        </Body2>
      </Box>
    </Box>
    <Button
      style={{ flex: '0 0 auto', minHeight: 48 }}
      width={['100%', 'auto', 'auto', 'auto']}
      onClick={onOrderClick}
      colorVariant={ButtonColorVariant.Primary}
      data-testid="orderOneOffBoxButton"
    >
      Order a one-off box
    </Button>
  </Box>
)
